import { SectionKey } from '../../schema/site'
import { sectionHeading } from '../../templates'

/**
 * What a section's card is called in the form.
 *
 * The heading the visitor will read, wherever the page has one, so "Galeria"
 * here and "Galeria" there cannot come apart. The sections with no heading of
 * their own (the top of the page, the hours with the contact, the map, the
 * review button) are named in the catalogue instead.
 */
export function sectionTitle(
  key: SectionKey,
  language: string,
  t: (key: string) => string
): string {
  switch (key) {
    case 'hero':
      return t('WEBSITE.SECTIONS.HERO')
    case 'visit':
      return t('WEBSITE.SECTIONS.VISIT')
    case 'map':
      return t('WEBSITE.SECTIONS.MAP')
    case 'review':
      return t('WEBSITE.SECTIONS.REVIEW')
    default:
      return sectionHeading(language, key)
  }
}
